import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { genAppRequestConfig } from "./appRequest";

/**
 * The shape of a Webop response body as it comes back from the server
 */

/**
 * Represents a fully processed Webop response. It includes a `success` property
 * which is generated when the response comes back based on the response body.
 */

/**
 * This function processes the response of a webop to decorate it with a `success` property
 * that indicates whether or not the request was successful. This is important because
 * we can receive error codes even though we get a 200 OK response.
 * @param data webop response object
 */
export var processWebopResponse = function processWebopResponse(stringData) {
  try {
    var _data = JSON.parse(stringData);
    if (!_data || !_data.serverStatus || _data.errorCode < 0 || !_data.data) {
      return _objectSpread(_objectSpread({}, _data), {}, {
        success: false
      });
    }
    return _objectSpread(_objectSpread({}, _data), {}, {
      success: true
    });
  } catch (e) {
    throw new Error("Failed to parse the webop response to an object. Probably because it isn't formatted as JSON.");
  }
};

/**
 * Generates an axios request config that's ready to send for a webop
 * @param config config object for the request
 * @param data data to send
 */
export var genWebopRequestConfig = function genWebopRequestConfig(config, data) {
  var conf = genAppRequestConfig(_objectSpread({
    formName: "webop"
  }, config), data);
  // this transformer will decorate the response data with the `success` property
  conf.transformResponse = [processWebopResponse];
  return conf;
};
//# sourceMappingURL=webOp.js.map